import { INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS } from './global-events';

export const insuranceCompaniesProductFilterOptions = [
  {
    id: 'all',
    name: 'Всі',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_ALL,
    options: {
      type: 'checkbox',
      activeFilter: false,
    },
  },
  {
    id: 'osago',
    name: 'ОСЦПВ',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_OSAGO,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'green_card',
    name: 'ЗК',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_GREEN_CARD,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'tourism',
    name: 'ТУРИЗМ',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_TOURISM,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'home',
    name: 'ЖИТЛО',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_HOME,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'manual',
    name: 'ЗОВНІШНІ ЗАМОВЛЕННЯ',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_EXTERNAL,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'miniKasko',
    name: 'МІНІКАСКО',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_MINI_KASKO,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'pets',
    name: 'СТРАХУВАННЯ ТВАРИН',
    event: INSURANCE_COMPANIES_PRODUCT_FILTER_EVENTS.INSURANCE_COMPANIES_PRODUCT_FILTER_PETS,
    options: {
      type: 'checkbox',
    },
  }
];
